export default {
  translations: {
    fields: {
      email: 'E-mail',
    },
  }
}
